export const searchFormOption = function () {
    return [
        {
            prop: 'keyword',
            label: '关键字',
            type: 'input',
            placeholder: '请输入车牌号/车架号'
        },
        {
            prop: 'carType',
            label: '车型',
            type: 'select',
            placeholder: '请选择车型',
            options: this.$store.state.app.carType
        },
    ]
}

// 新增车辆option
export const carFormOption = function() {
    return [
      {
        prop: 'upload',
        label: '行驶证扫描',
        slotName: 'uploadBtn'
      },
	  {
	    prop: 'textIdentify',
	    label: '文本识别',
	    type: 'textarea',
	    placeholder: '粘贴信息，自动拆分',
		rows:10
	  },
      {
        prop: 'carNo',
        label: '车牌号',
        type: 'input',
        placeholder: '请输入车牌号',
        minWidth: 150,
        // privacyType: true
      },
      {
        prop: 'vin',
        label: '车架号',
        type: 'input',
        placeholder: '请输入车架号',
        privacyType: true
      },
      {
        prop: 'engineNo',
        label: '发动机号',
        type: 'input',
        placeholder: '请输入发动机号',
        privacyType: true
      },
      {
        prop: 'beginDate',
        label: '初登日期',
        type: 'date',
        placeholder: '请选择初登日期'
      },
      {
        prop: 'usetype',
        label: '使用性质',
        type: 'select',
        placeholder: '请选择使用性质',
        options: this.$store.state.app.useType
      },
      {
        prop: 'carType',
        label: '车型',
        type: 'select',
        placeholder: '请选择使用性质',
        options: this.$store.state.app.carType,
        // privacyType: true
      },
      {
        prop: 'brandType',
        label: '品牌型号',
        type: 'input',
        placeholder: '请输入品牌型号',
        privacyType: true
      },
      // {
      //   prop: 'passengerCount',
      //   label: '核定载客(人)',
      //   type: 'input-number',
      // },
      // {
      //   prop: 'loadWeight',
      //   label: '核定载质量(kg)',
      //   type: 'input-number',
      // },
      // {
      //   prop: 'newPrice',
      //   label: '新车价',
      //   type: 'input',
      //   placeholder: '请输入新车价'
      // },
    ]
  }

export default {}